import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Confetti from 'react-confetti';
import "../css/ModalCongratsLevel.css";

import badge1 from '../assets/img/badges/1_badge_rabbit.png';
import badge2 from '../assets/img/badges/2_badge_deer.png';
import badge3 from '../assets/img/badges/3_badge_wolf.png';
import badge4 from '../assets/img/badges/4_badge_horse.png';
import badge5 from '../assets/img/badges/5_badge_bear.png';
import badge6 from '../assets/img/badges/6_badge_gorilla.png';
import badge7 from '../assets/img/badges/7_badge_lion.png';


const badgeMap = {
  1: badge1,
  2: badge2,
  3: badge3,
  4: badge4,
  5: badge5,
  6: badge6,
  7: badge7
};

function ModalCongratsLevel({ show, onHide, levelNumber }) {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (show) {
      console.log("🎊 Congrats modal triggered for level", levelNumber);
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }
  }, [show, levelNumber]);

  const badgeImage = badgeMap[levelNumber + 1] || badge7;

  return (
    <>
      {show && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={250}
          style={{ zIndex: 100005, position: "fixed", top: 0, left: 0 }}
        />
      )}
      <Modal
        show={show}
        onHide={onHide}
        centered
        style={{ zIndex: 100010 }} // 🔥 Ensure it's above everything
        backdropClassName="congrats-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Congratulations!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You’ve just unlocked <strong>Level {levelNumber + 1}</strong> and earned a new badge!</p>
          <img src={badgeImage} alt={`Badge for level ${levelNumber}`} style={{ maxWidth: '100%' }} />
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-home-link" onClick={onHide}>
            Let’s go!
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCongratsLevel;
